import { render, staticRenderFns } from "./PartnerQRCODE.vue?vue&type=template&id=1896aa3f&scoped=true"
import script from "./PartnerQRCODE.vue?vue&type=script&lang=js"
export * from "./PartnerQRCODE.vue?vue&type=script&lang=js"
import style0 from "./PartnerQRCODE.vue?vue&type=style&index=0&id=1896aa3f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1896aa3f",
  null
  
)

export default component.exports